<!--suppress ALL -->
<template>

  <div style="width: 100%;background-color: #f5f5f5;">

      <div class="nav_bar clear_both" v-if="showBar==true">
        <!--<button class="fl nav_bar_left_item" >-->
          <!--<img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" >-->
        <!--</button>-->
        <div class="goods-detail-bar"  id="bar">
          <div :class="[isBasic==true?'goods-detail-bar-each-choice':'goods-detail-bar-each']" @click="goBasic()">
            描述
          </div>
          <div :class="[isComment==true?'goods-detail-bar-each-choice':'goods-detail-bar-each']" @click="goComment">
            评价
          </div>
          <div :class="[isRecommended==true?'goods-detail-bar-each-choice':'goods-detail-bar-each']" @click="goRecommended()">
            推荐
          </div>
          <div :class="[isDescription==true?'goods-detail-bar-each-choice':'goods-detail-bar-each']" @click="goDescription()">
            详情
          </div>
        </div>
        <!--<div class="goods-detail-bar-title" v-if="showBar==false" id="bar">-->
          <!--商品详情-->
        <!--</div>-->
      </div>

      <!--基本信息-->
      <div id="body" style="width: 100%;">

        <!--banner-->
        <div class="goods-detail-banner">
          <van-swipe :autoplay="3000" class="goods-detail-banner">
            <van-swipe-item v-for="(bannerItem, index) in productDetail.imageList" :key="index">
              <van-image class="banner_item" fit="cover" :src="bannerItem" @click="getImg(index)"/>
            </van-swipe-item>
          </van-swipe>
        </div>

        <!--basic-->
        <div class="goods-detail-basic" id="basic">

          <div class="goods-basic-top">

            <div class="goods-basic-price">
                ¥{{productDetail.price}}
              <span class="goods-basic-originPrice">¥{{productDetail.markPrice}}</span>

              <div class="goods-basic-share" style="margin-left: 0.5rem" @click="showShareSheet=true">
                <img src="@/images/share@3x.png" v-if="distributionInfo.isDistributor!=0"/>
                <!--根据产品是否可分销进行分别展示-->
                <img style="width: 1.9rem;height: 1.6rem;position: absolute;margin-top: 0.6rem;" src="@/images/icon_Sharing revenue@3x.png" v-if="distributionInfo.isDistributor==0"/>
              </div>

              <van-popup v-model="showShareSheet" round position="bottom" :style="{ height: '20%' }" >
                <div class="ovh" style="padding: 1.5rem 2rem 0 2rem">
                  <div class="ovh fl tc" @click="shareFriend()">
                    <img style="width: 4rem" src="@/images/share_icon_1.png">
                    <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">发送给朋友</p>
                  </div>
                  <div class="ovh fl tc" @click="onSelectAction()">
                    <img style="width: 4rem" src="@/images/share_icon_2.png">
                    <p class="zt14 tc clear_style" style="color: #939598;width: 9rem;line-height: 1rem">生成海报</p>
                  </div>
                  <div class="ovh fl tc" @click="showShareSheet=false">
                    <img style="width: 4rem" src="@/images/share_icon_3.png">
                    <p class="zt14 tc clear_style" style="color: #939598;width: 5rem;line-height: 1rem">取消分享</p>
                  </div>
                </div>
              </van-popup>

              <div class="goods-basic-collection" @click="collection()">
                <img src="@/images/collection@3x.png" v-if="isCollection == 0"/>
                <img src="@/images/icon_Selection_Collection@3x.png" v-if="isCollection == 1"/>
              </div>

            </div>
            <div class="goods-basic-name">
              {{productDetail.productName}}
            </div>
          </div>

          <div class="goods-basic-activity" @click="showActivity()" v-if="productPromoList.length>0||productPromoCodeList.length>0">
            <div class="goods-basic-title">
              优惠
            </div>
            <div class="goods-basic-list">

              <div class="goods-basic-list-each" v-if="productPromoList.length>0">
                <div class="goods-basic-list-each-title">
                  折扣
                </div>
                <div class="goods-basic-list-each-right">
                  <div class="goods-basic-list-each-content" v-for="(promo,index) in productPromoList" :key="index">
                    {{promo.promoName}}
                  </div>
                </div>
              </div>

              <div class="goods-basic-list-each" v-if="productPromoCodeList.length>0">
                <div class="goods-basic-list-each-title">
                  领券
                </div>
                <div class="goods-basic-list-each-right">
                  <div class="goods-basic-list-each-content-code" v-for="(code,index) in productPromoCodeList" :key="index">
                    <div>
                      {{getPromoValue(code)}}{{getPromoType(code.type)}}
                    </div>
                    <img src="@/images/coupon@3x.png"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--choice-->
        <div class="goods-detail-choice">

          <div class="goods-detail-choice-each" @click="showSpec(0)">
            <div class="goods-detail-choice-title">
              选择
            </div>
            <div class="goods-detail-choice-desc">
              {{product.featDesc}}  共1件
            </div>
            <div class="goods-detail-choice-more">
              <img src="@/images/icon_arrow@3x.png"/>
            </div>
          </div>

          <div class="goods-detail-choice-each" @click="showParams()">
            <div class="goods-detail-choice-title">
              参数
            </div>
            <div class="goods-detail-choice-desc">
              品牌、型号、材质...
            </div>
            <div class="goods-detail-choice-more">
              <img src="@/images/icon_arrow@3x.png"/>
            </div>
          </div>

        </div>
      </div>

      <!--comment上线前先关掉-->
      <div class="goods-detail-comment" id="comment">
        <div class="goods-detail-comment-title" @click="goEval()">
          <div class="goods-detail-comment-num">评论({{commentNum}})</div>
          <div class="goods-detail-comment-more-icon">
            <img src="@/images/icon_arrow@3x.png">
          </div>
          <div class="goods-detail-comment-more">查看更多</div>
        </div>
        <div class="goods-detail-comment-tag">
          <div v-for="(tag,index) in tagList" :key="index">{{tag.tagName}}({{tag.tagNum}})</div>
        </div>
        <div class="goods-detail-comment-list">
          <div class="goods-detail-comment-each" v-for="(comment,index) in commentList" :key="index">
            <div class="goods-detail-comment-each-head">
              <div>
                <van-image :src="comment.partyImage">
                  <template v-slot:error></template>
                </van-image>
              </div>
              <div>
                {{comment.partyName}}
              </div>
            </div>
            <div class="goods-detail-comment-each-content">
              {{comment.productReview}}
            </div>
            <div class="goods-detail-comment-each-photo">
              <van-image v-for="(image,index) in comment.imageList" :key="index" :src="image">
                <template v-slot:error></template>
              </van-image>
            </div>
          </div>
        </div>
      </div>

      <!--recommended-->
      <div class="goods-detail-recommended" id="recommended" v-if="bestProductList.length>0">
        <div class="goods-detail-recommended-title">
          为你推荐
        </div>
        <div class="goods-detail-recommended-list">
          <div class="goods-detail-recommended-each" v-for="(product, index) in bestProductList" :key="index" @click="goDetail(product.productId)">
            <!--<router-link :to="{name:'goodsDetail',params:{goodsId:product.productId}}">-->
              <div class="goods-detail-recommended-each-photo">
                <van-image :src="product.detailImageUrl">
                  <template v-slot:error></template>
                </van-image>
              </div>
              <div class="goods-detail-recommended-each-name">
                {{product.productName}}
              </div>
              <div class="goods-detail-recommended-each-price">
                ¥{{product.price}}
              </div>
              <!--<van-image class="full_w gl_border" fit="cover" :src="produtItem.imageUrl" />-->
            <!--</router-link>-->
          </div>
        </div>
      </div>

      <!--description-->
      <div class="goods-detail-bottom" id="description">
        <div class="goods-detail-recommended-title">
          商品详情
        </div>
        <div v-html="description" class="goods-detail-recommended-desc"></div>
      </div>

      <!--footer-->
      <div class="goods-detail-footer">
        <div class="goods-detail-footer-left">
          <div class="goods-detail-footer-left-each" @click="goMenu()">
            <div>
              <img src="@/images/home@3x.png"/>
            </div>
            <div>
              首页
            </div>
          </div>
          <!--<div class="goods-detail-footer-left-each" @click="goCustomer()">-->
            <!--<div>-->
              <!--<img src="@/images/customer@3x.png"/>-->
            <!--</div>-->
            <!--<div>-->
              <!--客服-->
            <!--</div>-->
          <!--</div>-->
          <div class="goods-detail-footer-left-each" @click="goCar()">
            <div>
              <img src="@/images/Item 2@3x.png">
              <span class="goods-car-num" v-if="cartNum>0">
              {{cartNum}}
              </span>
            </div>
            <div>
              购物车
            </div>
          </div>
        </div>
        <div class="goods-detail-footer-right">
          <button @click="showSpec(1)">
            立即购买
          </button>
          <button @click="showSpec(2)">
            加入购物车
          </button>
        </div>
      </div>

      <!--参数上拉菜单-->
      <div class="goods-action-params-shadow" @click="hideParams()">
      </div>
      <div class="goods-action-content animate_action">
        <div class="goods-action-params-title">
          产品参数
        </div>
        <div class="goods-action-params-content">
          <loading v-show="paramsLoading"></loading>
          <table>
            <tr v-for="(param,index) in productParams" :key="index">
              <td>
                {{param.attrValue}}
              </td>
              <td>
                {{param.attrDescription}}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!--规格上拉菜单-->
      <div class="goods-action-spec-shadow" @click="hideSpec()">
      </div>
      <div class="goods-action-spec-content animate_action">
        <div class="goods-action-spec-goods">
          <div class="goods-action-spec-goodsImg">
            <van-image :src="product.image" fit="cover">
              <template v-slot:error></template>
            </van-image>
          </div>
          <div class="goods-action-spec-goodsInfo">
            <div class="goods-action-spec-goodsInfo-price">
              ¥{{product.price}}
            </div>
            <div class="goods-action-spec-goodsInfo-stock">
              库存:{{product.repertory}}
            </div>
            <div class="goods-action-spec-goodsInfo-spec">
              已选:{{product.featDesc}}
            </div>
          </div>
        </div>
        <div class="goods-action-spec-list">
          <loading v-show="specLoading"></loading>
          <div class="goods-action-spec-list-each" v-for="(feature,index) in  productFeature" :key="index" v-show="!specLoading">
            <div class="goods-action-spec-list-each-title">
              {{feature.description}}
            </div>
            <div class="goods-action-spec-list-each-list">
              <button v-for="(each,index) in feature.productFeatureList" :key="index" @click="choiceFeature(feature.productFeatureTypeId,each.productFeatureId,each.enable)"
                      :class="[each.status==1?'goods-action-spec-list-each-list-choice':each.status==2?'goods-action-spec-list-each-list-noChoice':'goods-action-spec-list-each-list-noAblechoice']">
                {{each.description}}
              </button>
            </div>
          </div>
        </div>
        <div class="goods-action-spec-list">
          <div class="goods-action-spec-list-each-title">
            数量
          </div>
          <div class="goods-action-spec-num">
            <button @click="lowNum()">
               -
            </button>
            <div>{{buyNum}}</div>
            <button @click="addNum()">
              +
            </button>
          </div>
        </div>
        <div class="goods-action-spec-button">
          <button @click="addCar()">确定</button>
        </div>
      </div>

      <!--优惠券/活动上拉菜单-->
      <div class="goods-action-activity-shadow" @click="hideActivity()">
      </div>
      <div class="goods-action-activity-content animate_action">
        <div class="goods-action-activity-title">
          优惠
        </div>

        <div class="goods-action-activity-content-bottom" v-if="productPromoObject.promoName">
          <div class="goods-action-activity-content-name">
            促销
          </div>
          <div class="goods-action-activity-content-list">
            <div class="goods-action-activity-content-list-left">
              <img src="@/images/icon_Promotion@3x.png"/>
            </div>
            <div class="goods-action-activity-content-list-right">
              <div class="goods-action-activity-desc">
                {{productPromoObject.promoName}}
              </div>
              <div class="goods-action-activity-time" v-if="productPromoObject.fromDate!=''&&productPromoObject.fromDate!=null&&productPromoObject.fromDate!=undefined">
                {{productPromoObject.fromDate|formatDate}}-{{productPromoObject.thruDate|formatDate}}
              </div>
            </div>
          </div>
        </div>

        <div class="goods-action-activity-content-bottom" v-if="productPromoCodeList.length>0">
          <div class="goods-action-activity-content-name">
            领券
          </div>
          <div class="full_w">
            <div class="coupon_item" v-for="(code,index) in productPromoCodeList" @key="index">
              <img style="position: absolute;width: 21.5rem" src="@/images/bj_coupon2@3x.png">
              <div style="position: absolute;width: 22rem;padding-top: 0.5rem">
                <div class="fl" style="width: 2rem;height: 3.3rem">
                  <p class="clear_style zt12 white" style="padding-left: 0.2rem;margin:0 auto;writing-mode: vertical-lr;width: 2rem;height: 5.5rem" :class="code.description.length > 7?'':'coupon_item_width'">{{code.description}}</p>
                </div>
                <div class="fl" style="padding-left: 1rem;margin-top: -0.6rem;width: 11rem">
                  <div>
                    <div class="clear_style zt48 blod tc fl wpurple" style="padding-left: 1rem;width: 6rem">{{getPromoValue(code)}}</div>
                    <div class="fl" style="padding-top: 0.7rem;margin-left: 0.5rem">
                      <p class="clear_style zt14 blod tc wpurple">{{getPromoType(code.type)}}</p>
                      <span class="zt14 blod wpurple">{{code.type=="discount"?'折':'RMB'}}</span>
                    </div>
                  </div>
                  <p class="clear_style zt10 tc fl full_w">
                    <span class="coupon_item_date wpurple">有效期:{{getPromoDate(code)}}</span>
                  </p>
                  <p class="clear_style zt14 white tc fl full_w" style="line-height: 1rem;height: 1.5rem;;overflow: hidden">{{code.productPromoName}}</p>
                </div>
                <button v-if="code.isHave == 1" class="zt12 white fr" style="border: 1px solid white;padding: 0.1rem 0.5rem;border-radius: 1.5rem;margin: 2rem 1.5rem;width: 5rem;">已领取</button>
                <button v-if="code.isHave == 2" class="zt12 white fr" style="border: 1px solid white;padding: 0.1rem 0.5rem;border-radius: 1.5rem;margin: 2rem 1.5rem;width: 5rem;"  @click="getProductPromoCode(code.productPromoId)">立即领取</button>
              </div>
            </div>
            <!--<div class="goods-action-activity-content-each" v-for="(code,index) in productPromoCodeList" :key="index">-->
              <!--<img src="@/images/bj_coupon2@3x.png">-->
              <!--<div class="goods-action-activity-content-each-left">-->
                <!--<div class="goods-action-activity-price">-->
                  <!--{{getPromoValue(code)}}-->
                <!--</div>-->
                <!--<div class="goods-action-activity-type">-->
                  <!--{{getPromoType(code.type)}}-->
                <!--</div>-->
              <!--</div>-->
              <!--<div class="goods-action-activity-content-each-right">-->
                <!--<div class="goods-action-activity-content-desc">-->
                  <!--{{code.productPromoName}}-->
                <!--</div>-->
                <!--<div class="goods-action-activity-content-time">-->
                  <!--<span>-->
                    <!--{{code.fromDate|formatDate}}-->
                  <!--</span>- -->
                  <!--<span>-->
                    <!--{{code.thruDate|formatDate}}-->
                  <!--</span>-->
                <!--</div>-->
                <!--<div class="goods-action-activity-content-status">-->
                  <!--<div class="goods-action-activity-content-status-desc">-->
                    <!--{{code.description}}-->
                  <!--</div>-->
                  <!--<div class="goods-action-activity-content-status-button">-->
                    <!--<button v-if="code.isHave == 1">立即领取</button>-->
                    <!--<button v-if="code.isHave == 2">已领取</button>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          </div>
        </div>
      </div>

      <van-overlay :show="showPopView" @click="showPopView = false" >
        <div class="ovh fr tr" style="margin-right: 4rem;margin-top: 1rem">
          <img class="fr" style="width: 2rem;margin-left: 1rem" src="@/images/share.png">
          <p class="zt16 fr white ovh tr">点击菜单分享给好友，立即赚取收益</p>
        </div>
      </van-overlay>

      <van-overlay :show="showImgView">
        <div v-show="!showShareLoading">
          <p v-if="showImgView" style="position: absolute;right: 0;margin: 0rem"><van-button @click="showImgView=false" color="#666" icon="close" type="default" size="small">关闭分享</van-button></p>
          <img class="full_w" :src="imgSrcUrl">
          <div v-if="showImgView" class="ovh zt16 tc white full_w" style="position: absolute;background-color: #EB84AB;height: 3rem;line-height: 3rem;margin-top: -3rem">. 长按保存图片 .</div>
        </div>
        <van-loading style="margin-top: 15rem" v-show="showShareLoading" size="24px" vertical>生成海报中...</van-loading>
      </van-overlay>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars,eqeqeq */

  import Vue from 'vue'
  import { storeName,prodCatalogId,shareUrl,severUrl,shareOnlineUrl,wxUrl } from '@/router/Constant'
  import { wxApi } from '@/router/wechat.js'
  import { getProductInfo,getBestProducts,getProductPromoList,getProductDescription,getProductAttributes,getProductFeature,getShoppingCartNum,addProductToCart,getProductReviews,updateProductCollectInfo,getWeixinShare,getDistributionDetail,boundTwoLevel,getProductPromoCode,getShareInfo,shareGetKcion,cartInsBuy} from '@/router/api'
  import { NavBar,Loading, Button ,Popup, Swipe,Image as ImageView,SwipeItem , Grid, Tabbar, Toast, ActionSheet, Search,ImagePreview, Dialog, Overlay} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie,GetQueryString ,setMiniProgramShare} from '@/utils/mUtil';
  import shareMaskBg from '@/images/bg_share_mask.png'

export default {
  name: 'goodsDetail',
  data () {
    return {
      productDetail: {},
      productParams: [],
      productPromoCodeList: [],
      productPromoList: [],
      bestProductList: [],
      description: '',
      productFeature: [],
      product: {},
      productPromoObject:{},
      productId:this.$route.query.goodsId,
      productStoreId:storeName,
      showLoading:true,
      buyNum:1,
      featureNum:0,
      prodCatalogId:prodCatalogId,
      isBasic:true,
      isComment:false,
      isRecommended:false,
      isDescription:false,
      showBar:false,
      isCollection:0,
      token:getStore('externalLoginKey'),
      specLoading:true,
      paramsLoading:true,
      cartNum:0,
      tagList:[],
      commentList:[],
      commentNum:0,
      addCartType:0,
      distributionInfo:{},
      authorization: 'Bearer ' + getCookie('authorization'),
      showShareSheet: false,
      showPopView:false,
      showImgView:false,
      shareActions: [{ name: '发送给朋友' }, { name: '生成海报' }],
      imgSrcUrl:'',
      showShareLoading:false,
      offsetTop:'',
    }
  },

  mounted () {

    this.init()
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
    // window.addEventListener('scroll',this.handleScroll,true)
    document.documentElement.scrollTop = 0
    // document.querySelector('body').style.overflow = 'scroll'
    // wxApi.wxRegister(this.wxRegCallback)

  },

  components: {
    [NavBar.name]: NavBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImageView.name]: ImageView,
    [Grid.name]: Grid,
    [Popup.name]: Popup,
    [Tabbar.name]: Tabbar,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Search.name]: Search,
    [ActionSheet.name]: ActionSheet,
    [Loading.name]:Loading,
    loading,
    [Dialog.name]: Dialog,
    [Overlay.name]: Overlay
  },

  filters: {
    formatDate: function (value) {
      if(value!=null&&value!=''&&value!=undefined ){
        let date = new Date(value)
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        return y + '.' + MM + '.' + d
      }else{
        return ''
      }
    }
  },

  methods: {

    async init(){
      if (this.$route.query.fromUrl) {
        setStore('giveAway',true)
      }
      this.creatQiYuAction()
      this.getPartyId()
      this.getProductInfo()
      this.getBestProducts()
      this.getProductPromoList()
      this.getProductDescription()
      this.getCartNum()
      this.changeFeature('', '')
      this.getProductReviews()
      // document.querySelector('.goods-detail-banner').style.height = window.screen.width+"px"
    },

    async creatQiYuAction(){
      // ysf('config', {
      //   uid: this.distributionInfo.partyId,      // 用户Id
      //   name: this.distributionInfo.name,          // 用户名称
      //   email: '', // 用户邮箱
      //   mobile: '',  // 用户电话
      //   level: 1,// vip级别
      //   success: function () {     // 成功回调
      //     //alert('2222')
      //     // window.location.href = ysf("url")
      //   },
      //   error: function () {       // 错误回调
      //     // handle error
      //     //alert('11111');
      //   }
      // });

    },

    creatQiYuProduct(){
      // ysf('product', {
      //   show : 1, // 1为打开， 其他参数为隐藏（包括非零元素）
      //   title : this.productDetail.productName,
      //   desc : this.productDetail.productName,
      //   picture : this.productDetail.imageList[0],
      //   price:this.productDetail.price,
      //   note : '',
      //   url : severUrl + '/#/goodsDetail?goodsId=' + this.productDetail.productId,
      //   success: function(){     // 成功回调
      //     //alert('设置成功')
      //   },
      //   error: function(){       // 错误回调
      //     // handle error
      //     //alert('设置失败')
      //   }
      // })
    },

    getPartyId:function() {
      console.log(window.location.href)
      if(window.location.href.indexOf('partyId')!=-1){
        if(getStore('islogIn') != 'true'){
          //用户未登陆
          // this.dialogAction('是否登陆会员系统');
        }else{
          //用户已登陆
          // 获得参数
          var currentUrl = window.location.href;
          var allParamArr = currentUrl.split("&");
          var partyId = "";
          for (var i = 0; i < allParamArr.length; i++) {
            if (allParamArr[i].indexOf("partyId") != -1) {
              partyId = allParamArr[i].split("=")[1];
              break;
            }
          }

          if (partyId ==undefined||partyId==null) {
            partyId = ""
          }

          var param = {
            partyId:partyId,externalLoginKey:this.token
          }
          console.log('param')
          console.log(param)

          boundTwoLevel({partyId:partyId,externalLoginKey:this.token})
            .then(res => {
              console.log(res)
              if(res._ERROR_MESSAGE_){
                // Toast({message:res._ERROR_MESSAGE_})
                console.log(res._ERROR_MESSAGE_)
              }else{
                console.log('绑定成功')
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }else{
        console.log('未获取到partyId')
      }
    },

    //获取产品基础数据
    getProductInfo:function(){
      // debugger
      let param = {
        externalLoginKey: this.token,
        productId: this.productId,
        productStoreId:this.productStoreId,
        prodCatalogId:prodCatalogId
      }

      getProductInfo(param)
        .then(res => {
          console.log('getProductInfo');
          console.log(res);
          this.productDetail = res.product;
          this.isCollection = this.productDetail.isCollect

          this.creatQiYuProduct()
          this.getDetail()
          setTimeout(() => {
            this.showLoading = false;
          }, 1000);
        })
        .catch(err => {
          console.log(err);
        });
    },

    //关联产品
    getBestProducts:function(){
      let params = {
        externalLoginKey: this.token,
        productId:this.productId,
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        viewIndex: 1,
        viewSize: 3
      }
      getBestProducts(params)
        .then(res => {
          console.log(res)
          this.bestProductList = res.resultMap.productList
        }).catch(err => {
        console.log(err)
      })
    },

    //产品促销活动
    getProductPromoList:function () {
      let activityList = {
        externalLoginKey: this.token,
        productId: this.productId,
        productStoreId: storeName,
        prodCatalogId:prodCatalogId,
      }
      getProductPromoList(activityList).then(res => {
        console.log(res)
        // 优惠券列表
        if(res.productPromoCodeList.length>0){
          this.productPromoCodeList = res.productPromoCodeList
        }else{
          this.productPromoCodeList = []
        }

        // 活动列表
        if(res.productPromoList.length>0){
          this.productPromoList = res.productPromoList
          this.productPromoObject = this.productPromoList[0]
        }else{
          this.productPromoList = []
          this.productPromoObject = {}
        }
        console.log(this.productPromoObject)
      }).catch(err =>{
        console.log(err)
      })
    },

    //产品图文详情
    getProductDescription:function(){
      getProductDescription({productId:this.productId,prodCatalogId:prodCatalogId,}).then(res => {
        console.log(res)
        this.description = res.description;
      }).catch(err => {
        console.log(err)
      })
    },

    //获取商品评论
    getProductReviews:function(){
      var params = {
        productId:this.productId,
        externalLoginKey:this.token,
        productStoreId:storeName,
        viewIndex:0,
        viewSize:1,
        tagId:''
      }
      getProductReviews(params)
        .then(res => {
          console.log(res);
          this.tagList = res.tagList
          this.commentList = res.resultMap.commentList
          this.commentNum = res.resultMap.listSize
        })
        .catch(err => {
          console.log(err);
        });
    },

    //产品参数
    getProductAttributes:function(){
      let paramList = {
        externalLoginKey: this.token,
        productId: this.productId,
        productStoreId: storeName,
        prodCatalogId:prodCatalogId,
      }
      getProductAttributes(paramList).then(res => {
        console.log(res)
        this.productParams = res.attributeList;
        this.paramsLoading = false
      }).catch(err =>{
        console.log(err)
      })
    },

    // 展示产品参数
    showParams: function () {
      this.getProductAttributes()
      document.querySelector('body').style.overflow = 'hidden'
      // document.querySelector('.nav_bar').setAttribute("style","z-index:1")
      document.querySelector('#basic').setAttribute("style","z-index:0")
      document.querySelector('.goods-action-content').style.overflow = 'scroll'
      document.querySelector('.goods-action-content').style.bottom = '0px'
      document.querySelector('.goods-action-params-shadow').style.bottom = '0px'
      this.paramsLoading = true
    },

    // 隐藏商品参数
    hideParams: function () {
      document.querySelector('body').style.overflow = 'scroll'
      // document.querySelector('.nav_bar').removeAttribute('style');
      document.querySelector('.goods-action-content').style.bottom = -window.innerHeight + 'px'
      document.querySelector('.goods-action-params-shadow').style.bottom = -window.innerHeight + 'px'
      this.paramsLoading = false
    },

    // 显示规格
    showSpec: function (type) {
      this.addCartType = type
      this.changeFeature('', '')
      document.querySelector('body').style.overflow = 'hidden'
      // document.querySelector('.nav_bar').setAttribute("style","z-index:1")
      document.querySelector('#basic').setAttribute("style","z-index:0")
      document.querySelector('.goods-action-spec-content').style.bottom = '0px'
      document.querySelector('.goods-action-spec-shadow').style.bottom = '0px'
      this.specLoading = true
    },

    // 隐藏规格
    hideSpec: function () {
      document.querySelector('body').style.overflow = 'scroll'
      // document.querySelector('.nav_bar').removeAttribute('style');
      document.querySelector('.goods-action-spec-content').style.bottom = -window.innerHeight + 'px'
      document.querySelector('.goods-action-spec-shadow').style.bottom = -window.innerHeight + 'px'
      this.paramsLoading = false
    },

    // 显示活动/优惠券
    showActivity: function () {
      document.querySelector('body').style.overflow = 'hidden'
      // document.querySelector('.nav_bar').setAttribute("style","z-index:1")
      document.querySelector('#basic').setAttribute("style","z-index:0")
      document.querySelector('.goods-action-activity-content').style.overflow = 'scroll'
      document.querySelector('.goods-action-activity-content').style.bottom = '0px'
      document.querySelector('.goods-action-activity-shadow').style.bottom = '0px'
    },

    // 隐藏活动/优惠券
    hideActivity: function () {
      document.querySelector('body').style.overflow = 'scroll'
      // document.querySelector('.nav_bar').removeAttribute('style');
      document.querySelector('.goods-action-activity-content').style.bottom = -window.innerHeight + 'px'
      document.querySelector('.goods-action-activity-shadow').style.bottom = -window.innerHeight + 'px'
    },

    share:function(){
      document.querySelector('body').style.overflow = 'hidden'
      // document.querySelector('.nav_bar').setAttribute("style","z-index:1")
      document.querySelector('#basic').setAttribute("style","z-index:0")
      document.querySelector('#shareContent').style.overflow = 'scroll'
      document.querySelector('#shareContent').style.bottom = '0px'
      document.querySelector('#shareShadow').style.bottom = '0px'
    },

    hideShare:function(){
      document.querySelector('body').style.overflow = 'scroll'
      // document.querySelector('.nav_bar').removeAttribute('style');
      document.querySelector('#shareContent').style.bottom = -window.innerHeight + 'px'
      document.querySelector('#shareShadow').style.bottom = -window.innerHeight + 'px'
    },

    // 用户选择规格
    choiceFeature: function (typeId, featureId, enable) {
      this.specLoading = true
      if (enable != 'N') {
        var feature = ''
        for (var i = 0; i < this.productFeature.length; i++) {
          for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
            if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
              feature += this.productFeature[i].productFeatureTypeId + ',' + this.productFeature[i].productFeatureList[j].productFeatureId + '|'
            }
          }
        }
        this.changeFeature(typeId + ',' + featureId, feature.substring(0,feature.length-1))
      } else {
        Toast('当前无此规格商品')
        this.specLoading = false
      }
    },

    // 用户修改规格
    changeFeature: function (nowFeature, feature) {
      let param = {
        productId: this.productId,
        productStoreId: storeName,
        nowFeature: nowFeature,
        feature: feature,
        prodCatalogId:prodCatalogId,
      }
      getProductFeature(param).then( res=> {
        console.log(res)
        this.productFeature = res.featureList
        for(var i = 0;i<this.productFeature.length;i++){
          for(var j = 0;j<this.productFeature[i].productFeatureList.length;j++){
            if(this.productFeature[i].productFeatureList[j].enable=='Y'&&this.productFeature[i].productFeatureList[j].isSelect=='Y'){
              this.productFeature[i].productFeatureList[j].status = 1
            }else if(this.productFeature[i].productFeatureList[j].enable=='Y'&&this.productFeature[i].productFeatureList[j].isSelect=='N'){
              this.productFeature[i].productFeatureList[j].status = 2
            }else if(this.productFeature[i].productFeatureList[j].enable=='N'){
              this.productFeature[i].productFeatureList[j].status = 3
            }
          }
        }
        this.product = res.product
        if(this.product.repertory>0){
          document.querySelector('.goods-action-spec-button button').setAttribute('style','background-color:#EB84AB')
        }else{
          document.querySelector('.goods-action-spec-button button').setAttribute('style','background-color:#e5e5e5')
        }
        this.getChoiceFeature()
        this.specLoading = false
      }).catch(err => {
        console.log(err)
        this.specLoading = false
        Toast('获取失败')
      })
    },

    //获取用户所选规格名称
    getChoiceFeature:function(){
      var featDesc = ''
      for (var i = 0; i < this.productFeature.length; i++) {
        for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
          if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
            featDesc += this.productFeature[i].productFeatureList[j].description + ','
          }
        }
        this.product.featDesc = featDesc.substring(0, featDesc.length - 1)
      }
    },

    //用户添加产品数量
    addNum:function () {
      if(this.buyNum<this.product.repertory){
        this.buyNum++
      }else{
        Toast({message:'很遗憾，商品没有库存了'})
      }
    },

    //用户减少产品数量
    lowNum:function () {
      if(this.buyNum>1){
        this.buyNum--
      }else{
        Toast({message:'已是最小购买量'})
      }
    },

    //用户点击规格确定按钮
    addCar:function () {
      if(this.addCartType==1||this.addCartType==2){
        //用户已登陆
        this.featureNum = 0
        for (var i = 0; i < this.productFeature.length; i++) {
          for (var j = 0; j < this.productFeature[i].productFeatureList.length; j++) {
            if (this.productFeature[i].productFeatureList[j].isSelect == 'Y') {
              this.featureNum ++
            }
          }
        }
        if(this.featureNum == this.productFeature.length){
          if(this.buyNum>this.product.repertory){
            Toast('此商品没有库存了')
          }else{
              //判断用户是否登陆
            if (getStore('islogIn') != 'true') {
              this.dialogAction('添加商品需要登录，是否现在登录？');
            } else{
              if(this.addCartType==2){
                this.addProductCart()
              }else{
                this.cartInsBuy()
              }

            }
          }
        }else{
          Toast({message:'您还没有选择商品规格'})
        }
      }else{
        this.hideSpec()
      }
    },

    //添加购物车方法
    addProductCart:function(){
      let paramList = {
        externalLoginKey: this.token,
        productId: this.product.productId,
        productStoreId: storeName,
        quantity:this.buyNum,
        prodCatalogId:prodCatalogId,
      }
      addProductToCart(paramList).then(res => {
        console.log(res)
        console.log('addProductToCart')
        if(res._ERROR_MESSAGE_==undefined){
          this.hideSpec()
          Toast({message:'添加成功'})
          this.getCartNum()
        }else{
          Toast({message:res._ERROR_MESSAGE_})
        }

      }).catch(err =>{
        console.log(err)
      })
    },

    //用户点击立即购买
    cartInsBuy:function(){
      let paramList = {
        externalLoginKey: this.token,
        productId: this.product.productId,
        productStoreId: storeName,
        quantity:this.buyNum,
        prodCatalogId:prodCatalogId,
      }
      cartInsBuy(paramList).then(res => {
        console.log(res)
        console.log('cartInsBuy')
        if(res._ERROR_MESSAGE_){
          Toast({message:res._ERROR_MESSAGE_})
          this.hideSpec()
        }else{
          Toast({message:'添加成功'})
          document.querySelector('body').style.overflow = 'scroll'
          this.$router.push({path:'/orderComfirm'})
          // this.$router.push({name:'emptyView'})
        }

      }).catch(err =>{
        console.log(err)
      })
    },

    //获取购物车内商品数量
    getCartNum:function(){
      let paramList = {
        externalLoginKey: this.token,
        productStoreId: storeName,
        prodCatalogId:prodCatalogId,
      }
      getShoppingCartNum(paramList).then(res => {
        console.log(res)
        this.cartNum = res.catNum
      }).catch(err =>{
        console.log(err)
      })
    },

    //用户点击基本信息
    goBasic:function(){
      document.querySelector('#basic').scrollIntoView(true);
      this.isBasic = true;
      this.isComment = false;
      this.isRecommended = false;
      this.isDescription = false
    },

    //用户点击评价标签
    goComment:function () {
      document.querySelector('#comment').scrollIntoView(true);
      this.isBasic = false;
      this.isComment = true;
      this.isRecommended = false;
      this.isDescription = false
    },

    //用户点击推荐标签
    goRecommended:function () {
      document.querySelector('#recommended').scrollIntoView(true);
      this.isBasic = false;
      this.isComment = false;
      this.isRecommended = true;
      this.isDescription = false
    },

    //用户点击详情
    goDescription:function () {
      document.querySelector('#description').scrollIntoView(true);
      this.isBasic = false;
      this.isComment = false;
      this.isRecommended = false;
      this.isDescription = true
    },

    //页面滚动事件
    handleScroll:function (e) {
      let scrollY = document.documentElement.scrollTop
      if(document.querySelector('#basic')!=undefined){
        if(scrollY > 0&&scrollY<=document.querySelector('#basic').offsetTop){
          this.isComment = false
          this.isBasic = true
          this.isRecommended = false
          this.isDescription = false
        }else if(scrollY > document.querySelector('#basic').offsetTop&&scrollY <= document.querySelector('#comment').offsetTop){
          this.isComment = true
          this.isBasic = false
          this.isRecommended = false
          this.isDescription = false
        }else if(scrollY > document.querySelector('#comment').offsetTop&&scrollY <= document.querySelector('#recommended').offsetTop){
          this.isComment = false
          this.isBasic = false
          this.isRecommended = true
          this.isDescription = false
        }else if(scrollY > document.querySelector('#recommended').offsetTop&&scrollY <= document.querySelector('#description').offsetTop){
          this.isComment = false
          this.isBasic = false
          this.isRecommended = false
          this.isDescription = true
        }else{
          this.isComment = false
          this.isBasic = true
          this.isRecommended = false
          this.isDescription = false
        }
      }


      if(scrollY>100 && this.showImgView){
        this.showBar = true;
      }else{
        this.showBar = false;
      }

    },

    //页面离开时销毁监听事件
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);
    },

    //产品收藏事件
    collection:function () {
      if (getStore('islogIn') != 'true') {
        this.dialogAction('收藏商品需要登录，是否现在登录？');
      } else{
        //用户已登陆
        this.collect()
      }
    },

    //用户点击确定登陆按钮
    dialogAction(msg){
      Dialog.confirm({
        message: msg
      }).then(() => {
        if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
          wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
      }).catch(() => {

      });
    },

    //执行用户收藏方法
    collect:function(){
      let paramList = {
        externalLoginKey: this.token,
        productId: this.productId,
        productStoreId: storeName,
      }
      updateProductCollectInfo(paramList).then(res => {
        console.log(res)
        if(res._EVENT_MESSAGE){
          if(this.isCollection == 0){
            this.isCollection = 1
            Toast({message:'收藏成功'})
          }else{
            this.isCollection = 0
            Toast({message:'取消收藏成功'})
          }
        }else{
          if(this.isCollection == 0){
            Toast({message:'收藏失败'})
          }else{
            Toast({message:'取消收藏失败'})
          }
        }

      }).catch(err =>{
        console.log(err)
      })
    },

    //图片预览
    getImg: function (index) {
      ImagePreview({
        images:this.productDetail.imageList,
        showIndex:true,
        loop:false,
        startPosition:index
      })
    },

    //跳转商品详情
    goDetail:function (productId){
      this.$router.push({name:'goodsDetail',query:{goodsId:productId}})
      setStore('onRefresh',"onRefresh")
      window.location.reload()
    },

    //跳转至商品评级
    goEval:function(){
      this.$router.push({name:'goodsEvaluation',query:{productId:this.productId}})
    },

    //跳转至首页
    goMenu:function () {
      this.$router.push({name:'home'})
      // this.$router.push({name:'emptyView'})
    },

    //跳转至购物车
    goCar:function () {
      if (getStore('islogIn') != 'true') {
        this.dialogAction('跳转购物车需要登录，是否现在登录？');
      } else{
        //用户已登陆
        this.$router.push({name:'cart'})
        // this.$router.push({name:'emptyView'})
      }
    },

    //判断优惠券类型
    getPromoType(type) {
      var typeName = '';
      switch (type) {
        case 'gift':
          typeName = '礼品券'
          break;
        case 'discount':
          typeName = '折扣券'
          break;
        case 'deduct':
          typeName = '满减券'
          break;
        case 'special':
          typeName = '特价券'
          break;
        default:
          break
      }
      return typeName
    },

    getPromoDate(item) {
      var msg = ""
      if (item.fromDate == null && item.thruDate == null) {
        msg = "不限制时间使用"
      }
      if (item.fromDate == null && item.thruDate != null) {
        msg = "截止到" + this.formatDate(item.thruDate) + "失效"
      }
      if (item.fromDate != null && item.thruDate == null) {
        msg = this.formatDate(item.fromDate) + "后开始使用"
      }
      if (item.fromDate != null && item.thruDate != null) {
        msg = this.formatDate(item.fromDate) + "-" + this.formatDate(item.thruDate)
      }
      return msg
    },

    formatDate(value) {
      if(value!=null&&value!=''&&value!=undefined ){
        let date = new Date(value)
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        return y + '.' + MM + '.' + d
      }else{
        return ''
      }
    },

    //判断优惠券折扣类型
    getPromoValue(code) {
      var promoValue = '';
      switch (code.type) {
        case 'gift':
          promoValue = '赠品'
          break;
        case 'discount':
          if (code.value == 0) {
            promoValue = '免费'
          } else {
            if ((parseInt(code.value, 10) === code.value)==true) {
              promoValue = code.value + '.0'
            } else {
              promoValue = code.value
            }
          }
          break;
        case 'deduct':
          promoValue = code.value
          break;
        case 'special':
          if (code.value == 0) {
            promoValue = '免费'
          } else {
            promoValue = code.value
          }
          break;
        default:
          break
      }
      return promoValue
    },

    getPromoDate(item) {
      var msg = ""
      if (item.fromDate == null && item.thruDate == null) {
        msg = "不限制时间使用"
      }
      if (item.fromDate == null && item.thruDate != null) {
        msg = "截止到" + this.formatDate(item.thruDate) + "失效"
      }
      if (item.fromDate != null && item.thruDate == null) {
        msg = this.formatDate(item.fromDate) + "后开始使用"
      }
      if (item.fromDate != null && item.thruDate != null) {
        msg = this.formatDate(item.fromDate) + "-" + this.formatDate(item.thruDate)
      }
      return msg
    },

    //获取当前分销人信息
    getDetail:function(){
      let param = {
        externalLoginKey: this.token,
      }
      getDistributionDetail(param)
        .then(res => {
          console.log("getDistributionDetail");
          console.log(res);
          if(!res._ERROR_MESSAGE_){
            //成功
            this.distributionInfo = res.resultMap
            this.creatQiYuAction()
          }else{
            Toast({message:res._ERROR_MESSAGE_})
          }
          //var that = this

          // ysf('config', {
          //   uid: this.distributionInfo.partyId,      // 用户Id
          //   name: this.distributionInfo.name,          // 用户名称
          //   email: '', // 用户邮箱
          //   mobile: '',  // 用户电话
          //   level: 1,// vip级别
          //   success: function () {     // 成功回调
          //     alert('2222')
          //     ysf('open');
          //   },
          //   error: function () {       // 错误回调
          //     // handle error
          //     alert('11111');
          //   }
          // });

          setMiniProgramShare(this.productDetail.productName,this.productDetail.imageList[0],wxUrl+encodeURIComponent(shareOnlineUrl+'goodsDetail')+'&goodsId='+this.productId+'&partyId='+this.distributionInfo.partyId)


          // this.getConfig()
        })
        .catch(err => {
          setMiniProgramShare(this.productDetail.productName,this.productDetail.imageList[0],wxUrl+encodeURIComponent(shareOnlineUrl+'goodsDetail')+'&goodsId='+this.productId+'&partyId='+this.distributionInfo.partyId)

          // this.getConfig()
          console.log(err);
        });
    },


    //转发给朋友
    shareFriend:function(){
      this.showShareSheet=false
      this.showPopView = true
      this.shareGetKcion()
    },

    //文章转发获得K币
    shareGetKcion:function(){
      shareGetKcion({externalLoginKey:this.token})
        .then(res => {
          console.log('转发成功')
          console.log(res)

        })
        .catch(err => {
          console.log(err);
        });
    },


    //获取当前分享的内容
    getConfig:function(){
      let param;
      var u = navigator.userAgent, app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        //这个是安卓操作系统
        param = 'android'
      }
      if (isIOS) {
        //这个是ios操作系统
        param = 'ios'
      }
      let paramList = {
        url: window.location.href,
        os:param
      }
      getWeixinShare(paramList).then(res => {
        console.log(res)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.shareMap.appId, // 必填，公众号的唯一标识
          timestamp: res.shareMap.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.shareMap.nonceStr, // 必填，生成签名的随机串
          signature: res.shareMap.signature,// 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });

        var thisBlock = this
        wx.ready(function(){
          wx.updateAppMessageShareData({
            title: thisBlock.productDetail.productName, // 分享标题
            desc: '新入会员，立享50元新人礼券', // 分享描述
            link: shareUrl+'?/goodsDetail?goodsId='+thisBlock.productDetail.productId+'&partyId='+thisBlock.distributionInfo.partyId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
            imgUrl: thisBlock.productDetail.imageList[0], // 分享图标
            success: function () {
            },error:function () {
            }
          })

          //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: thisBlock.productDetail.productName,
            desc: '新入会员，立享50元新人礼券',
            link: shareUrl+'?/goodsDetail?goodsId='+thisBlock.productDetail.productId+'&partyId='+thisBlock.distributionInfo.partyId,
            // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
            imgUrl: thisBlock.productDetail.imageList[0],
            success: function () {
            },error:function () {
            }
          })
        });

      })
    },

    //跳转至客服
    goCustomer:function () {
      //跳转至小程序
      // wx.miniProgram.navigateTo({url:'../../pages/kefu1/kefu/kefu'})
      // window.location.href = ysf("url")
    },

    // 用户领取优惠券
    getProductPromoCode(id) {
      console.log(id)
      getProductPromoCode({externalLoginKey:getStore('externalLoginKey'),Authorization:this.authorization,productPromoId:id,productStoreId: storeName})
        .then(res => {
          console.log("getProductPromoCode")
          console.log(res)
          if (res._ERROR_MESSAGE_) {
            Toast.fail(res._ERROR_MESSAGE_);
          } else {
            Toast(res._EVENT_MESSAGE_);
            Toast.success('领取成功');
            this.getProductPromoList()
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSelectAction() {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showShareSheet = false;
      console.log("生成海报中")
      this.showImgView = true
      this.showShareLoading = true
      this.getShareInfo();
    },

    onCancel(){
      this.showShareSheet = false;
    },

    getShareInfo() {
      var qrCodeContent = shareUrl+'?/goodsDetail?goodsId='+this.productDetail.productId+'&partyId='+this.distributionInfo.partyId
      console.log({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: storeName})
      getShareInfo({externalLoginKey:getStore('externalLoginKey'),qrCodeContent:qrCodeContent,productStoreId: storeName})
        .then(res => {
          console.log("getShareInfo")
          console.log(res)
          if (res._ERROR_MESSAGE_) {
            Toast.fail(res._ERROR_MESSAGE_);
          } else {
            console.log(res._EVENT_MESSAGE_)

            // 当店铺是零售的时候，零售的店铺需要的参数为二维码图片和头部的图片
            if (storeName == 'OnlineStore') {
              if (res.qrImg != '' && res.headImg != '' && res.qrImg != undefined && res.headImg != undefined) {
                setTimeout(() => {
                  this.doMyCanvas(res.qrImg,res.headImg)
                }, 1000);
              } else {
                Toast.fail("请联系管理员完成分享配置")
                this.showShareLoading = false
                this.showImgView = false
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    doMyCanvas(imgQr,headImg) {
      var param = {
        width: window.outerWidth * 2, // 卡牌宽度
        height: window.outerHeight * 2, // 卡
        imgBG: this.productDetail.imageList[0], //背景
        imgBGMask:shareMaskBg,
        imgHead:headImg,
        imgQr: imgQr, // 卡牌底部二维码
      };

      console.log(param)

      // var c= document.getElementById('canvas');
      var c = document.createElement('canvas');
      var ctx = c.getContext("2d");

      c.width = param.width;
      c.height = param.height;
      var myCanvas = c;
      var img = new Image();
      img.crossOrigin = 'Anonymous'
      img.src = param.imgBG;
      img.onload = () => {

        // 设置背景为白色
        var imageData = ctx.getImageData(0, 0, c.width, c.height);
        for(var i = 0; i < imageData.data.length; i += 4) {
          // 当该像素是透明的,则设置成白色
          if(imageData.data[i + 3] == 0) {
            imageData.data[i] = 255;
            imageData.data[i + 1] = 255;
            imageData.data[i + 2] = 255;
            imageData.data[i + 3] = 255;
          }
        }
        ctx.putImageData(imageData, 0, 0);

        var bGH = 945
        var startX = 50 + (param.width - 750)/2
        console.log("param.height" + param.height)
        console.log("startY======" + startY)
        var startY = (param.height - bGH - 250) / 2  // 最小的内容区域为1100px

        // 设置背景图
        var goodsImgWidth = param.width * 2
        var goodsImgHeight = param.width * 2
        var oData,newSrc;
        ctx.drawImage(img, -(goodsImgWidth-param.width)/2, -(goodsImgHeight-param.width)/2/2 + startY/2, goodsImgWidth, goodsImgHeight);
        oData = ctx.getImageData(0,0,param.width,param.height);
        newSrc = this.gaussBlur(oData);
        ctx.putImageData(newSrc, 0, 0);

        // 设置蒙版遮罩
        var maskImgW = param.width
        var maskImgH = param.height
        var maskImg = new Image()
        maskImg.crossOrigin = 'Anonymous'
        maskImg.src = param.imgBGMask
        maskImg.onload = () => {

          ctx.drawImage(maskImg, 0, 0, maskImgW, maskImgH);

          // 画圆角矩形
          this.fillRoundRect(ctx,startX,startY,param.width - (startX * 2),bGH,20)

          startX += 30
          startY += 40
          // 设置商品头图
          var headImg = new Image();
          headImg.crossOrigin = 'Anonymous'
          headImg.src = param.imgHead
          headImg.onload = () => {
            console.log(startX,startY,param.width - startX*2, 100)
            ctx.drawImage(headImg, startX,startY,param.width - startX*2, 100);
            // 设置商品主图
            startY += 100 + 30
            var goodsImg = new Image();
            goodsImg.crossOrigin = 'Anonymous'
            goodsImg.src = param.imgBG
            goodsImg.onload = () => {
              ctx.drawImage(goodsImg, startX, startY, param.width - startX*2, param.width - startX*2);

              // 设置商品名称
              startY += (param.width - startX*2 + 60)
              ctx.font = 'normal 32px Microsoft YaHei';
              ctx.textAlign = 'left';
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = '#6d6e70';
              ctx.fillText(this.productDetail.productName, startX, startY);

              // 设置商品价格
              startY += 50
              ctx.font = 'normal 32px Microsoft YaHei';
              ctx.textAlign = 'left';
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = '#EB84AB';
              ctx.fillText("¥ " + this.productDetail.price, startX, startY);

              // 设置分享人名称
              ctx.font = 'normal 32px Microsoft YaHei';
              ctx.textAlign = 'right';
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = '#6d6e70';
              ctx.fillText(this.distributionInfo.name, param.width - startX, startY);

              // 设置提示
              startY += 50
              ctx.font = 'normal 28px Microsoft YaHei';
              ctx.textAlign = 'right';
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = '#b2b3b6';
              ctx.fillText('"分享给你我的快乐！"', param.width - startX, startY);

              // 画二维码圆角矩形
              var qrw = 150
              startY += 40
              startX += (param.width - startX * 2 - qrw)/2
              this.fillRoundRect(ctx,startX,startY,qrw,qrw,20)

              // 设置二维码图
              startY += 5
              startX += 5
              var qrImg = new Image();
              qrImg.crossOrigin = 'Anonymous'
              qrImg.src = param.imgQr
              qrImg.onload = () => {
                ctx.drawImage(qrImg, startX, startY, qrw-10, qrw-10);

                // 设置长按二维码提示
                startY += qrw + 50
                startX = param.width / 2
                ctx.font = 'normal 28px Microsoft YaHei';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#fff';
                ctx.fillText("长按识别二维码 发现更多精彩", startX, startY);

                var imgUrl = c.toDataURL('image/jpeg', 2.0);
                console.log(imgUrl)
                this.showShareLoading = false
                this.imgSrcUrl = imgUrl
              }
            }
          }
        }
      };
    },

    fillRoundRect(cxt, x, y, width, height, radius) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) { return false; }

      cxt.save();
      cxt.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius);
      cxt.fillStyle = "white"; //若是给定了值就用给定的值否则给予默认值
      cxt.fill();
      cxt.restore();
    },

    drawRoundRectPath(cxt, width, height,radius) {
      var  r0 = radius,r1 = radius,r2 = radius,r3 = radius;
      cxt.beginPath(0);
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - r0, height - r0, r0, 0, Math.PI / 2);

      //矩形下边线
      cxt.lineTo(r1, height);

      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(r1, height - r1, r1, Math.PI / 2, Math.PI);

      //矩形左边线
      cxt.lineTo(0, r2);

      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(r2, r2, r2, Math.PI, Math.PI * 3 / 2);

      //上边线
      cxt.lineTo(width - r3, 0);

      //右上角圆弧
      cxt.arc(width - r3, r3, r3, Math.PI * 3 / 2, Math.PI * 2);

      //右边线
      cxt.lineTo(width, height - r3);
      cxt.closePath();
    },

    gaussBlur(imgData) {
      var pixes = imgData.data;
      var width = imgData.width;
      var height = imgData.height;
      var gaussMatrix = [],
        gaussSum = 0,
        x, y,
        r, g, b, a,
        i, j, k, len;

      var radius = 50;
      var sigma = 10;

      a = 1 / (Math.sqrt(2 * Math.PI) * sigma);
      b = -1 / (2 * sigma * sigma);
      //生成高斯矩阵
      for (i = 0, x = -radius; x <= radius; x++, i++){
        g = a * Math.exp(b * x * x);
        gaussMatrix[i] = g;
        gaussSum += g;

      }
      //归一化, 保证高斯矩阵的值在[0,1]之间
      for (i = 0, len = gaussMatrix.length; i < len; i++) {
        gaussMatrix[i] /= gaussSum;
      }
      //x 方向一维高斯运算
      for (y = 0; y < height; y++) {
        for (x = 0; x < width; x++) {
          r = g = b = a = 0;
          gaussSum = 0;
          for(j = -radius; j <= radius; j++){
            k = x + j;
            if(k >= 0 && k < width){//确保 k 没超出 x 的范围
              //r,g,b,a 四个一组
              i = (y * width + k) * 4;
              r += pixes[i] * gaussMatrix[j + radius];
              g += pixes[i + 1] * gaussMatrix[j + radius];
              b += pixes[i + 2] * gaussMatrix[j + radius];
              // a += pixes[i + 3] * gaussMatrix[j];
              gaussSum += gaussMatrix[j + radius];
            }
          }
          i = (y * width + x) * 4;
          // 除以 gaussSum 是为了消除处于边缘的像素, 高斯运算不足的问题
          // console.log(gaussSum)
          pixes[i] = r / gaussSum;
          pixes[i + 1] = g / gaussSum;
          pixes[i + 2] = b / gaussSum;
          // pixes[i + 3] = a ;
        }
      }
      //y 方向一维高斯运算
      for (x = 0; x < width; x++) {
        for (y = 0; y < height; y++) {
          r = g = b = a = 0;
          gaussSum = 0;
          for(j = -radius; j <= radius; j++){
            k = y + j;
            if(k >= 0 && k < height){//确保 k 没超出 y 的范围
              i = (k * width + x) * 4;
              r += pixes[i] * gaussMatrix[j + radius];
              g += pixes[i + 1] * gaussMatrix[j + radius];
              b += pixes[i + 2] * gaussMatrix[j + radius];
              // a += pixes[i + 3] * gaussMatrix[j];
              gaussSum += gaussMatrix[j + radius];
            }
          }
          i = (y * width + x) * 4;
          pixes[i] = r / gaussSum;
          pixes[i + 1] = g / gaussSum;
          pixes[i + 2] = b / gaussSum;
        }
      }
      //end
      return imgData;
    }
  },

  // destroyed () {
  //   ysf('logoff')
  // },

}

</script>

<style>

  .nav_bar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: fixed;
    top:0;
    z-index: 9;
    width: 100%;
    background: white;
    height: 2rem;
    line-height: 2rem;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .animate_action {
    transition:all .4s;
  }

  .bar-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .bar-enter, .bar-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .goods-detail-bar{
    display: inline-block;
    vertical-align: top;
    width:100%;
    opacity: 1;
  }
  .goods-detail-bar div{
    width:calc(100% / 4);
    float: left;
    text-align: center;
    height: 2rem;
    line-height: 2rem;
    font-size:0.875rem;
  }
  .goods-detail-bar-each{
    color:#333312;
  }
  .goods-detail-bar-each-choice{
    color:#EB84AB;
  }
  .goods-detail-bar-title{
    text-align: center;
    display: inline-block;
    vertical-align: top;
    height: 2rem;
    line-height: 2rem;
    padding-left: 7em;
  }

  /*banner*/
  .goods-detail-back{
    background-color: #F5F5F5;
    width:100%;
    height: 100%;
  }
  .goods-detail-banner{
    height: 23.4375rem;
    background-color: white;
  }
  .banner_item {
    width: 100%;
    height: 100%;
  }
  .banner_item img{
    border-radius:0;
  }

  /*商品基本信息*/
  .goods-detail-basic{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .goods-basic-top{
    border-bottom: 1px solid #c7c7c7;
    border-top: 1px solid #E7E7E7;
  }
  .goods-basic-price{
    width:100%;
    height: 3.125rem;
    line-height: 3.125rem;
    color:#EB84AB;
    font-size: 1.21875rem;
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-basic-originPrice{
    color:#9E9E9E;
    font-size: 0.78125rem;
    text-decoration:line-through;
  }
  .goods-basic-collection{
    float:right;
  }
  .goods-basic-collection img{
    width:1.25rem;
    height: 1.25rem;
  }
  .goods-basic-share{
    float:right;
    width:1.25rem;
    height: 1.25rem;
  }
  .goods-basic-share img{
    width:100%;
    height: 100%;
  }
  .goods-basic-name{
    width:21.4375rem;
    margin: 0 auto;
    padding-bottom: 0.9375rem;
    font-size: 0.9375rem;
    color:#333312;
  }
  .goods-basic-activity{
    width:21.4375rem;
    margin: 0 auto;
    padding: 0.5rem 0;
  }
  .goods-basic-title{
    display: inline-block;
    vertical-align: top;
    width:2rem;
    font-size: 0.78125rem;
    color:#999999;
    line-height: 2rem;
  }
  .goods-basic-list{
    width:calc(100% - 3rem);
    display: inline-block;
    vertical-align: top;
  }
  .goods-basic-list-each{
    width:100%;
    /*line-height: 2rem;*/
  }
  .goods-basic-list-each-title{
    font-size: 0.6875rem;
    color:white;
    display: inline-block;
    vertical-align: top;
    background-color: #EB84AB;
    border-radius: 2rem;
    width: 2.5rem;
    height: 1.2rem;
    text-align: center;
    line-height: 1.2rem;
    margin-top: 0.4rem;
    margin-right: 0.1rem;
  }
  .goods-basic-list-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3rem);
    padding-top: 0.4rem;
  }
  .goods-basic-list-each-content{
    font-size:0.875rem;
    color:#333312;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.1rem;
  }
  .goods-basic-list-each-content-code{
    font-size:0.75rem;
    color:#FF0000;
    /*width:4.6875rem;*/
    min-width: 4.6875rem;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
    height: 1.125rem;
    line-height: 1.125rem;
    margin-bottom: 0.5rem;
    padding: 0 0.5rem;
  }
  .goods-basic-list-each-content-code img{
    width:4.6875rem;
    /*width:100%;*/
    height: 1.125rem;
    position:relative;
    top:-1.1rem;
  }

  /*商品参数、规格*/
  .goods-detail-choice{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .goods-detail-choice-each{
    width:21.4375rem;
    margin: 0 auto;
    height: 3.125rem;
    line-height: 3.125rem;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-detail-choice-title{
    display: inline-block;
    vertical-align: top;
    font-size: 0.78125rem;
    color:#9E9E9E;
  }
  .goods-detail-choice-desc{
    display: inline-block;
    vertical-align: top;
    font-size: 0.71825rem;
    color:#333;
  }
  .goods-detail-choice-more{
    display: inline-block;
    vertical-align: top;
    float: right;
    width:1.375rem;
    height: 1.375rem;
    margin-top: 0.35rem;
  }
  .goods-detail-choice-more img{
    width:100%;
    height: 100%;
  }

  /*商品评价*/
  .goods-detail-comment{
    width:100%;
    background-color: white;
    margin-bottom:0.625rem;
  }
  .goods-detail-comment-title{
    width:21.4375rem;
    margin: 0 auto;
    height: 3rem;
    line-height: 3rem;
  }
  .goods-detail-comment-more-icon{
    width:1.375rem;
    height: 1.375rem;
    float: right;
    margin-top: 0.35rem;
  }
  .goods-detail-comment-more-icon img{
    width:100%;
    height: 100%;
  }
  .goods-detail-comment-num{
    font-size: 0.90625rem;
    color:#333333;
    display: inline-block;
    vertical-align: top;
  }
  .goods-detail-comment-more{
    font-size: 0.78125rem;
    color:#9E9E9E;
    text-align: right;
    display: inline-block;
    vertical-align: top;
    float: right;
    margin-right: 0.5rem;
  }
  .goods-detail-comment-tag{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-detail-comment-tag div{
    background-color: #FFB9C6;
    height: 1.40625rem;
    line-height: 1.40625rem;
    color:white;
    border-radius: 0.703125rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
    margin-bottom: 0.625rem;
    font-size: 0.75rem;
    padding: 0 0.46875rem;
  }
  .goods-detail-comment-list{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-detail-comment-each{
    width:100%;
  }
  .goods-detail-comment-each-head{
    width:100%;
    height: 2rem;
    line-height: 2rem;
  }
  .goods-detail-comment-each-head div{
    display: inline-block;
    vertical-align: top;
    color:#333;
    font-size:0.6875rem;
    width:1.75rem;
    height: 1.75rem;
  }
  .goods-detail-comment-each-head div .van-image{
    width:1.75rem;
    height: 1.75rem;
    border-radius: 5.625rem;
    /*margin-top: 0.5rem;*/
  }
  .goods-detail-comment-each-content{
    width:100%;
    font-size:0.875rem;
    color:#33312E;
    margin:0.5rem auto 0.5rem;
    padding-bottom: 0.5rem;
  }
  .goods-detail-comment-each-photo{
    width:100%;
  }
  .goods-detail-comment-each-photo .van-image{
    width:5rem;
    height: 5rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }

  /*商品推荐*/
  .goods-detail-recommended{
    width:100%;
    background-color: white;
    margin-bottom:0.625rem;
  }
  .goods-detail-bottom{
    width:100%;
    background-color: white;
    margin-bottom:3.0625rem;
  }
  .goods-detail-recommended-title{
    width:21.4375rem;
    margin: 0 auto;
    font-size: 0.90625rem;
    height: 2.5rem;
    line-height: 2.5rem;
    color:#33312E;
  }
  .goods-detail-recommended-desc{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-detail-recommended-list{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-detail-recommended-each{
    width:6.5rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.5rem;
    margin-bottom: 0.625rem;
  }
  .goods-detail-recommended-each-photo{
    width:100%;
    height:5.625rem;
  }
  .goods-detail-recommended-each-photo .van-image{
    width:100%;
    height: 100%;
  }
  .goods-detail-recommended-each-name{
    width:100%;
    height: 2.5rem;
    line-height: 2.5rem;
    color:#9E9E9E;
    font-size: 0.71825rem;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
  }
  .goods-detail-recommended-each-price{
    text-align: center;
    font-size:0.875rem;
    color:#33312E;
  }

  /*商品参数*/
  .goods-action-params-shadow{
    width:100%;
    height: 100%;
    display: block;
    position: fixed;
    background: rgba(0,0,0,0.4);
    z-index: 99;
  }
  .goods-action-content{
    width:100%;
    height:21.84375rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom:-21.84375rem;
    z-index: 99;
  }
  .goods-action-params-title{
    width:21.4375rem;
    margin: 0 auto;
    color:#333312;
    font-size: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
  }
  .goods-action-params-content{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-action-params-content table{
    width:100%;
    border-collapse:collapse;
  }
  .goods-action-params-content table tr{
    width:100%;
    border-bottom: 1px solid #E7E7E7;
    line-height: 2rem;
  }
  .goods-action-params-content table tr td{
    text-align: left;
    font-size: 0.75rem;
    display: inline-block;
    float: left;
  }
  .goods-action-params-content table tr td:first-child{
    width:5.25rem;
    color:#999;
  }
  .goods-action-params-content table tr td:last-child{
    color:#333312;
    width:calc(100% - 6rem);
  }

  /*商品规格*/
  .goods-action-spec-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: block;
    z-index: 99;
  }
  .goods-action-spec-content{
    width:100%;
    height:31.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    z-index: 99;
  }
  .goods-action-spec-goods{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .goods-action-spec-goodsImg{
    width:6.25rem;
    height: 6.25rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
  }
  .goods-action-spec-goodsImg .van-image{
    width:100%;
    height: 100%;
  }
  .goods-action-spec-goodsInfo{
    width:calc(100% - 7.25rem);
    display: inline-block;
    vertical-align: top;
  }
  .goods-action-spec-goodsInfo-price{
    font-size:1rem;
    color:#333312;
    margin-bottom: 1.25rem;
  }
  .goods-action-spec-goodsInfo-stock{
    font-size: 0.875rem;
    color:#666;
    margin-bottom: 0.625rem;
  }
  .goods-action-spec-goodsInfo-spec{
    font-size: 0.875rem;
    color:#666;
  }
  .goods-action-spec-list{
    width:21.4375rem;
    margin: 0 auto;
    max-height: 14rem;
    overflow: scroll;
  }
  .goods-action-spec-list-each{
    width:100%;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-spec-list-each-title{
    font-size: 1rem;
    color:#333312;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
  .goods-action-spec-list-each-list{
    width:100%;
  }
  .goods-action-spec-list-each-list div{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .goods-action-spec-list-each-list button{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .goods-action-spec-list-each-list-noChoice{
    border: 1px solid #999;
    color: #333312;
  }
  .goods-action-spec-list-each-list-choice{
    border: 1px solid #EB84AB;
    color: #EB84AB;
  }
  .goods-action-spec-list-each-list-noAblechoice{
    border: 1px solid #e5e5e5;
    color: #e5e5e5;
  }
  .goods-action-spec-num{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-action-spec-num button{
    display: inline-block;
    vertical-align: top;
    /*height: 1.5rem;*/
    line-height: 1.5rem;
    border-radius: 0.1rem;
    border: 1px solid #999;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    color: #333312;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    text-align: center;
  }
  .goods-action-spec-num div{
    display: inline-block;
    vertical-align: top;
    font-size: 1rem;
    color:#333312;
    margin-right: 0.625rem;
    height: 1.625rem;
    line-height: 1.625rem;
  }
  .goods-action-spec-button{
    width:18.75rem;
    margin: 0 auto;

  }
  .goods-action-spec-button button{
    width:18.75rem;
    position: absolute;
    bottom: 0.5rem;
    background-color: deeppink;
    color:white;
    font-size:1rem;
    text-align: center;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 2rem;
  }

  /*商品分享*/
  .goods-share-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: block;
    z-index: 99;
  }
  .goods-share-content{
    width:100%;
    height:9rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -9rem;
    z-index: 99;
  }
  .goods-share-head{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-share-head-each{
    display: inline-block;
    vertical-align: top;
    width:5rem;
    height: 5rem;
    margin-top:1rem;
    margin-right: 1rem;
  }
  .goods-share-head-each button{
    display: inline-block;
    vertical-align: top;
    background-color: #eee;
    color:#333;
    font-size:0.75rem;
    width:4rem;
    height: 2rem;
    text-align: center;
  }




  /*商品活动/优惠券*/
  .goods-action-activity-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: block;
    z-index: 99;
  }
  .goods-action-activity-content{
    width:100%;
    height:31.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    z-index: 99;
  }
  .goods-action-activity-title{
    width:21.4375rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size:1rem;
    color:#333312;
  }
  .goods-action-activity-content-bottom{
    width:21.4375rem;
    margin:0 auto;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-activity-content-name{
    font-size:1rem;
    color:#333312;
    height: 3rem;
    line-height: 3rem;
   }
  .goods-action-activity-content-list{
    width:100%;
  }
  .goods-action-activity-content-each{
    width:100%;
    height: 6.875rem;
    margin-bottom: 0.3125rem;
  }
  .goods-action-activity-content-each img{
    width:100%;
    height: 100%;
  }
  .goods-action-activity-content-list-left{
    display: inline-block;
    vertical-align: top;
    width:2rem;
  }
  .goods-action-activity-content-list-left img{
    width:1.25rem;
    height:0.90625rem;
  }
  .goods-action-activity-content-list-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.5rem);
  }
  .goods-action-activity-content-each-left{
    display: inline-block;
    vertical-align: top;
    width:6rem;
    height: 6rem;
    position: relative;
    top: -6.8rem;
    left: 0.5rem;
    text-align: center;
  }
  .goods-action-activity-price{
    color:white;
    font-size: 1.71875rem;
    height: 1.71875rem;
    line-height: 1.71875rem;
    margin-top: 1.5rem;
  }
  .goods-action-activity-type{
    color:white;
    font-size: 0.75rem;
    height: 0.75rem;
    line-height: 0.75rem;
    margin-top: 0.5rem;
  }
  .goods-action-activity-content-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 7rem);
    height: 6rem;
    position:relative;
    top: -6.5rem;
    left: 1rem;
  }
  .goods-action-activity-content-desc{
    color:#EB84AB;
    font-size:0.9375rem;
    margin-bottom: 0.6875rem;
  }
  .goods-action-activity-content-time{
    color:#666;
    font-size:0.625rem;
    margin-bottom: 0.5rem;
  }
  .goods-action-activity-content-status{
    width:100%;
    height: 1.40625rem;
  }
  .goods-action-activity-content-status-desc{
    color:#999;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width: 8rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    height: 1.40625rem;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button{
    width:4.6875rem;
    height: 1.40625rem;
    display: inline-block;
    vertical-align: top;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button button{
    width:100%;
    font-size: 0.75rem;
    color:#EB84AB;
    text-align: center;
    line-height: 1.40625rem;
    border-radius:0.703125rem;
    border:1px solid #EB84AB;
  }
  .goods-action-activity-desc{
    color:#EB84AB;
    font-size:1rem;
  }
  .goods-action-activity-time{
    font-size:0.875rem;
    color:#999;
    line-height: 2rem;
  }
  .goods-detail-footer{
    width:100%;
    height: 3.0625rem;
    background-color: white;
    position: fixed;
    bottom: 0px;
  }
  .goods-detail-footer-left{
    width:8.8125rem;
    height: 100%;
    float: left;
    /*display: inline-block;*/
    /*vertical-align: top;*/
  }
  .goods-detail-footer-left-each{
    display: inline-block;
    vertical-align: top;
    width:calc(100% / 2 - 20px);
    text-align: center;
  }

  /*.goods-detail-footer-left-each{*/
    /*display: inline-block;*/
    /*vertical-align: top;*/
    /*width:2.5rem;*/
    /*text-align: center;*/
  /*}*/
  .goods-detail-footer-left-each div:first-child{
    width:1.375rem;
    height: 1.375rem;
    margin-top: 0.5rem;
    margin-left: 0.925rem;

  }
  /*.goods-detail-footer-left-each div:first-child{*/
    /*width:1.375rem;*/
    /*height: 1.375rem;*/
    /*margin-top: 0.5rem;*/
    /*margin-left: 0.625rem;*/

  /*}*/
  .goods-detail-footer-left-each img{
    width:100%;
    height: 100%;
  }
  .goods-detail-footer-left-each div:last-child{
    font-size: 0.625rem;
    color:#4D4A45;
  }
  .goods-detail-footer-right{
    width:calc(100% - 8.8125rem);
    float: right;
    height: 100%;
  }
  .goods-detail-footer-right button{
    width:calc(100% / 2);
    float: right;
    height: 100%;
    padding: 0px;
    color:white;
    font-size: 0.8125rem;
  }
  .goods-detail-footer-right button:first-child{
    background-color:#AF97E7 ;
  }
  .goods-detail-footer-right button:last-child{
    background-color: #FFB9C6;
  }
  .goods-car-num{
    width:0.9375rem;
    height: 0.9375rem;
    border-radius:5.625rem;
    background-color: #EB84AB;
    color:white;
    font-size: 0.5rem;
    text-align: center;
    line-height: 0.9375rem;
    display: inline-block;
    position: relative;
    top: -2.1rem;
    left: 0.6rem;
  }

  .coupon_item {
    height: 7rem;
    padding: 0.25rem 0rem;
  }

  .coupon_item_width {
    width: 1rem!important;
  }

  .coupon_item_date {
    line-height: 1rem;border-top: 1px solid #6547AA;padding-top: 0.4rem;
  }

  .van-overlay {
    z-index: 99;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/goods/goodsDetail.vue